import { StyleSheet } from 'react-native';
import { IS_IOS } from '@/utils/platform';
import colors, { appTheme } from '@/config/colors';

export const styles = StyleSheet.create({
  setImageWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  exerciseSetImageStyle: {
    flex: 1,
    width: '100%',
    resizeMode: 'contain',
    borderRadius: 1,
  },
  exerciseSetImageCard: {
    width: '55%',
    height: '55%',
    borderColor: '#6d6c7c',
    borderStyle: 'solid',
    position: 'absolute',
    zIndex: 1,
    backgroundColor: 'white',
  },
  imageStackBackground: {
    zIndex: 0,
    borderColor: '#6d6c7c',
    borderStyle: 'solid',
    width: '55%',
    height: '55%',
    marginLeft: '5%',
    marginTop: '5%',
    backgroundColor: '#e8e7e7',
    transform: IS_IOS ? [{ rotate: '0deg' }] : [{ rotate: '2deg' }],
  },
  imageBorderRadius: {
    borderRadius: 1,
  },
  allowTherapistSwitchContainer: {
    alignItems: 'center',
  },
  allowTherapistSwitchWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '75%',
    backgroundColor: colors.white,
  },

  linkStyle: { color: colors.darkPurpleBlue },

  centerPosition: {
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
  },
  header: {
    padding: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  full1: {
    flex: 1,
  },
  full2: {
    flex: 2,
  },
  textHeader: {
    color: appTheme.textColor,
  },
  centerCardContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 20,
  },
  paddingForMobileCardContainer: {
    padding: 7,
  },

  mobileRedirectWrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  width90Height90: {
    width: '90%',
    height: '90%',
  },
  exercisesetCard: {
    backgroundColor: colors.white,
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
});
